// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_h-2";
export var blackBorderOnHover = "_h-7";
export var cell = "_h-6";
export var cellContainer = "_h-3";
export var checked = "_h-8";
export var disabled = "_h-5";
export var featuredIconCellContainer = "_h-9";
export var featuredIconTextContainer = "_h-b";
export var featuredIconWrapper = "_h-a";
export var noBorder = "_h-c";
export var orangeSelectedRow = "_m-3";
export var overflowableText = "_h-0";
export var overflowableTextContainer = "_h-1";
export var row = "_f-0";
export var rowCheckboxCell = "_h-4";
export var selectableTable = "_m-2";